import { FC, ReactElement } from "react";

const Expand:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M5.574 8.994l-3.29 3.29-1.284-1.284c-0.553 0-1 0.447-1 1v3c0 0.553 0.447 1 1 1h3c0.553 0 1-0.447 1-1l-1.284-1.283 3.29-3.291-1.432-1.432zM15 0h-3c-0.553 0-1 0.448-1 1l1.284 1.284-3.29 3.29 1.432 1.432 3.29-3.29 1.284 1.284c0.553 0 1-0.447 1-1v-3c0-0.552-0.447-1-1-1zM15 11l-1.284 1.284-3.29-3.29-1.432 1.432 3.29 3.291-1.284 1.283c0 0.553 0.447 1 1 1h3c0.553 0 1-0.447 1-1v-3c0-0.553-0.447-1-1-1zM5 1c0-0.552-0.447-1-1-1h-3c-0.553 0-1 0.448-1 1v3c0 0.553 0.447 1 1 1l1.284-1.284 3.29 3.29 1.432-1.432-3.29-3.29 1.284-1.284z"></path>
        </svg>
    )
}

export default Expand;